import React from 'react'
import { Block, ImageWithContent } from '@components'

const DatoCmsImageWithContent = ({
  paddingTop,
  paddingBottom,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters={props.width !== 'Full Width'}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={props.background}
      backgroundStyle={backgroundStyle}
    >
      <ImageWithContent elevated {...props} />
    </Block>
  )
}

export default DatoCmsImageWithContent
